function clean(value?: string | null): string {
  return String(value || '').replace(/\s+/g, ' ').trim()
}

function titleCasePhrase(value: string): string {
  const small = new Set(['a', 'an', 'and', 'are', 'as', 'by', 'for', 'from', 'in', 'of', 'on', 'or', 'the', 'to', 'with'])
  return clean(value)
    .replace(/\//g, ' / ')
    .split(' ')
    .filter(Boolean)
    .map((word, index) => {
      const lower = word.toLowerCase()
      if (lower === 'and') return '&'
      if (['ai', 'gpu', 'hpc', 'ev', 'ato', 'apra', 'rba', 'sec', 'euv', 'aws'].includes(lower)) return lower.toUpperCase()
      if (lower === 'capex') return 'Capex'
      if (small.has(lower) && index > 0) return lower
      return word.split('-').filter(Boolean).map((part) => part.charAt(0).toUpperCase() + part.slice(1).toLowerCase()).join('-')
    })
    .join(' ')
}

function truncate(value: string, limit: number): string {
  const text = clean(value)
  if (text.length <= limit) return text
  return `${text.slice(0, Math.max(0, limit - 1)).trim()}...`
}

export function compactWorkspaceTitle(title?: string | null, originalQuestion?: string | null, headline?: string | null): string {
  const rawTitle = clean(title)
  const rawQuestion = clean(originalQuestion)
  const source = rawQuestion || rawTitle
  const shouldSummarize = !rawTitle || rawTitle.length > 72 || /^among\b/i.test(rawTitle) || /^which\b/i.test(rawTitle) || rawTitle.endsWith('...')

  if (shouldSummarize && source) {
    const question = source.replace(/[?\s]+$/g, '')
    const whichMatch = question.match(/\bwhich\s+(.+)$/i)
    if (whichMatch) {
      const phrase = clean(whichMatch[1])
      const subject = clean(phrase.split(/\s+(?:have|has|are|is|will|would|should)\s+/i)[0]).replace(/\b(holdings|companies|candidates|names|stocks)\b/gi, '').replace(/[,:-]+$/g, '').trim()
      const objectiveMatch = phrase.match(/(?:confirming\s+or\s+falsifying|confirming|falsifying|show(?:ing)?\s+whether|evidence\s+for)\s+(.+?)(?:\s+over\s+|\s+within\s+|\s+before\s+|\s+by\s+|$)/i)
      const objective = clean(objectiveMatch?.[1] || '')
      if (objective) {
        const topic = `${titleCasePhrase(objective)} Signals`
        return truncate(subject ? `${titleCasePhrase(subject)}: ${topic}` : topic, 82)
      }
    }

    const compact = question
      .replace(/^among\s+.+?,\s*/i, '')
      .replace(/^which\s+/i, '')
      .replace(/\s+over\s+the\s+next\s+\d+\s+(?:months?|years?).*$/i, '')
      .replace(/\s+over\s+next\s+\d+\s+(?:months?|years?).*$/i, '')
      .replace(/[,:?\s-]+$/g, '')
    const titled = titleCasePhrase(compact)
    if (titled) return truncate(titled, 82)
  }

  return rawTitle || clean(headline) || 'Forecast workspace'
}

export function workspaceTitleWasSummarized(title?: string | null, originalQuestion?: string | null, headline?: string | null): boolean {
  return compactWorkspaceTitle(title, originalQuestion, headline) !== clean(title)
}
